import { t as gsapWithCSS } from "@theme/gsap";
import { t as ensureScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/science-scroller.js
var ANIM_DURATION = .3;
var ANIM_EASE = "linear";
function tweenCircleColor(circle, vars) {
	gsapWithCSS.to(circle, {
		...vars,
		duration: ANIM_DURATION,
		ease: ANIM_EASE,
		onStart: () => {
			circle.style.transition = "none";
		},
		onComplete: () => {
			circle.style.transition = "";
		}
	});
}
var ScienceScroller = class extends window.HTMLElement {
	async connectedCallback() {
		if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
		if (!window.location.hash) window.scrollTo({
			top: 0,
			left: 0,
			behavior: "instant"
		});
		const ScrollTrigger = await ensureScrollTrigger();
		const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
		const transitionPoint = isDesktop ? 35 : 65;
		const thresholdY = window.innerHeight * transitionPoint / 100;
		this._triggers = [];
		const players = gsapWithCSS.utils.toArray(this.querySelectorAll("dotlottie-player"));
		const circles = gsapWithCSS.utils.toArray(this.querySelectorAll(".science-progress-circle"));
		const chapters = gsapWithCSS.utils.toArray(this.querySelectorAll(".science-chapter-content"));
		let activeIndex = 0;
		chapters.forEach((chapter, i) => {
			if (i === chapters.length - 1) return;
			if (chapter.getBoundingClientRect().bottom <= thresholdY) activeIndex = i + 1;
		});
		players.forEach((p, i) => {
			gsapWithCSS.set(p, { opacity: i === activeIndex ? 1 : 0 });
			if (i === activeIndex) p.play();
		});
		circles.forEach((c, i) => {
			gsapWithCSS.set(c, {
				backgroundColor: i === activeIndex ? "oklch(28.159% 0.03802 158.033)" : "oklch(95.386% 0.02894 102.743)",
				color: i === activeIndex ? "oklch(95.386% 0.02894 102.743)" : "oklch(28.159% 0.03802 158.033)"
			});
		});
		chapters.forEach((chapter, i) => {
			if (i === chapters.length - 1) return;
			const current = players[i];
			const next = players[i + 1];
			const currentCircle = circles[i];
			const nextCircle = circles[i + 1];
			this._triggers.push(ScrollTrigger.create({
				trigger: chapter,
				start: `bottom ${transitionPoint}%`,
				end: `bottom ${transitionPoint}%`,
				onEnter: () => {
					if (ScrollTrigger.isRefreshing) return;
					gsapWithCSS.to(current, {
						opacity: 0,
						onComplete: () => current.pause()
					});
					gsapWithCSS.to(next, { opacity: 1 });
					next.play();
					tweenCircleColor(currentCircle, {
						backgroundColor: "oklch(95.386% 0.02894 102.743)",
						color: "oklch(28.159% 0.03802 158.033)"
					});
					tweenCircleColor(nextCircle, {
						backgroundColor: "oklch(28.159% 0.03802 158.033)",
						color: "oklch(95.386% 0.02894 102.743)"
					});
					document.dispatchEvent(new CustomEvent("science:chapter-change", { detail: { index: i + 1 } }));
				},
				onEnterBack: () => {
					if (ScrollTrigger.isRefreshing) return;
					gsapWithCSS.to(current, { opacity: 1 });
					gsapWithCSS.to(next, {
						opacity: 0,
						onComplete: () => next.pause()
					});
					current.play();
					tweenCircleColor(currentCircle, {
						backgroundColor: "oklch(28.159% 0.03802 158.033)",
						color: "oklch(95.386% 0.02894 102.743)"
					});
					tweenCircleColor(nextCircle, {
						backgroundColor: "oklch(95.386% 0.02894 102.743)",
						color: "oklch(28.159% 0.03802 158.033)"
					});
					document.dispatchEvent(new CustomEvent("science:chapter-change", { detail: { index: i } }));
				}
			}));
		});
		document.dispatchEvent(new CustomEvent("science:chapter-change", { detail: { index: activeIndex } }));
		if (!isDesktop) {
			const headings = gsapWithCSS.utils.toArray(this.querySelectorAll("[data-mobile-chapter-heading]"));
			let mobileCtaIndex = 0;
			headings.forEach((heading, i) => {
				if (heading.getBoundingClientRect().top <= window.innerHeight) mobileCtaIndex = i;
			});
			headings.forEach((heading, i) => {
				if (i === 0) return;
				this._triggers.push(ScrollTrigger.create({
					trigger: heading,
					start: "top bottom",
					end: "top bottom",
					onEnter: () => {
						if (ScrollTrigger.isRefreshing) return;
						document.dispatchEvent(new CustomEvent("science:mobile-cta-change", { detail: { index: i } }));
					},
					onEnterBack: () => {
						if (ScrollTrigger.isRefreshing) return;
						document.dispatchEvent(new CustomEvent("science:mobile-cta-change", { detail: { index: i - 1 } }));
					}
				}));
			});
			document.dispatchEvent(new CustomEvent("science:mobile-cta-change", { detail: { index: mobileCtaIndex } }));
		}
	}
	disconnectedCallback() {
		this._triggers?.forEach((t) => t.kill());
	}
};
window.customElements.define("science-scroller", ScienceScroller);
//#endregion
